export const NOW_SELLER_MODAL_ID = 'now-seller-modal'
export const NOW_SELLER_MODAL_CONTAINER_ID = 'now-seller-modal-container'
